import { render, staticRenderFns } from "./Pos_sales_by_tag.vue?vue&type=template&id=7a22313e&"
import script from "./Pos_sales_by_tag.vue?vue&type=script&lang=js&"
export * from "./Pos_sales_by_tag.vue?vue&type=script&lang=js&"
import style0 from "./Pos_sales_by_tag.vue?vue&type=style&index=0&id=7a22313e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports